/**
 * Ledger analytics endpoints (bos-api).
 *
 * Paths are relative to the axios client's base, which already ends in
 * `/api/v1` — so `/ledger/analytics/financial-position` reaches
 * `…/api/v1/ledger/analytics/financial-position`.
 *
 * Under `/ledger/analytics`, not `/ledger/statements`: the statements report
 * what was recorded and are read by an accountant; this reads *across* them and
 * answers "how is the business doing" for someone who is not one.
 */

export type FinancialPositionQuery = {
    /** ISO `YYYY-MM-DD`. Omitted means today, decided server-side. */
    asOf?: string;
    /** Which locale the server should resolve the zone summary into. */
    locale: string;
};

const search = (entries: Record<string, string>): string => {
    const query = new URLSearchParams(entries).toString();
    return query ? `?${query}` : '';
};

export const AnalyticsEndpoints = {
    /** GET — the zone, the readiness checklist, and the four metrics. */
    financialPosition: ({ asOf, locale }: FinancialPositionQuery) =>
        `/ledger/analytics/financial-position${search({
            ...(asOf ? { asOf } : {}),
            locale,
        })}`,
};
